var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-list"},_vm._l((_vm.orders),function(order){return _c('OrderPrintTemplate',{key:order.id,attrs:{"order":order,"order-items":order.completeTracking.processing.length
        ? order.completeTracking.processing
        : order.products}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }